// src/lib/phone.ts

/**
 * Build an E.164 `tel:` href from a human-formatted US phone string.
 * Strips non-digits and normalizes to a leading +1 country code.
 */
export function telHref(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  const national = digits.length === 11 && digits.startsWith("1")
    ? digits.slice(1)
    : digits;
  return `tel:+1${national}`;
}
